module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-sm-12"
  }, [_c('div', {
    staticClass: "employee-box"
  }, [_c('div', {
    staticClass: "image"
  }, [(_vm.image) ? _c('img', {
    attrs: {
      "src": _vm.image
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/images/avatar.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                " + _vm._s(_vm.name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_vm._v("\n                " + _vm._s(_vm.position) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60724a37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/employee.vue
// module id = 265
// module chunks = 1